<div [ngClass]="controlClass">
	<div class="sort-download-group">
		@if(enableColumnSelection){
		<div class="column-selector">
			<simple-selector
				[label]="`Columns`"
				[menuOptions]="columnOptions"
				(select)="selectedColumn($event)"
			>
			</simple-selector>
		</div>
		} @if(enableDownload) {
		<div class="export">
			<div
				class="button"
				[ngClass]="{ 'menu-open': showMenu }"
				(click)="setShowMenu($event)"
			>
				<div class="label" [ngClass]="{ 'menu-open': showMenu }">
					{{ download }}
				</div>
				<div class="icon" [ngClass]="{ 'menu-open': showMenu }"></div>
			</div>
			@if(showMenu){
			<div class="export-menu">
				<div class="item" (click)="exportAsCSV()">
					<div class="icon csv"></div>
					<div class="label">
						{{ downloadCSV }}
					</div>
				</div>
				<div class="item pdf" (click)="exportAsPDF()">
					<div class="icon pdf"></div>
					<div class="label">
						{{ downloadPDF }}
					</div>
				</div>
			</div>
			}
		</div>
		}
	</div>
</div>
<table [ngClass]="tableClass">
	<tr>
		<th class="header">
			@if(showCheckbox) {
			<input
				type="checkbox"
				class="checkbox"
				[checked]="areAllFollowed()"
				(click)="toggleFollowAll()"
			/>}
		</th>
		@if(forUpdate){
		<th></th>
		} @for(column of visibleColumns; track column){
		<th style="cursor: pointer" class="header" (click)="sortBy(column)">
			{{ getHeaderText(column) }}
		</th>
		} @if(forUpdate){
		<th></th>
		}
	</tr>
	@for(asset of assets; track asset.assetId) {
	<tr [ngStyle]="getStylesForRow()" (click)="rowClicked(asset)">
		<td>
			@if(showCheckbox) {
			<input
				type="checkbox"
				class="checkbox"
				[checked]="isFollowingAsset(asset)"
				(click)="toggleFollowingAsset(asset)"
			/>
			}
		</td>
		@if(forUpdate){
		<td>
			@if( isModified(asset.assetId)){
			<div class="flag-icon"></div>
			} @if(hasRequiredChanges(asset)){
			<span class="required">{{ requiredLabel }} </span>}
		</td>
		} @for(column of visibleColumns; track column){
		<td
			(click)="selectValue(asset, column)"
			[ngStyle]="getStylesForProperty(column)"
		>
			{{ getValue(asset, column) }}
		</td>
		} @if(forUpdate){
		<th class="edit-label">
			+{{
				updateMode === SelfUpdateModes.Edit
					? Loc(LocalizedTextIds.Edit)
					: Loc(LocalizedTextIds.Review)
			}}
		</th>
		@if(updateMode === SelfUpdateModes.Review &&
		updateForReview.assetUpdates[asset.assetId]) {
		<approve-decline
			[asset]="asset"
			[includeInSummary]="updateForReview.assetUpdates[asset.assetId]"
		>
		</approve-decline
		>} }
	</tr>
	}
</table>
